{
  "es": {
    "actions": {
      "hangarShare": {
        "enable": "Crear enlace para compartir",
        "rotate": "Renovar enlace",
        "disable": "Eliminar enlace para compartir"
      },
      "announcements": {
        "addPart": "Añadir",
        "removePart": "Quitar",
        "movePartUp": "Subir",
        "movePartDown": "Bajar",
        "sendTest": "Enviar prueba",
        "publish": "Enviar",
        "retry": "Reintentar",
        "refreshEngagement": "Actualizar cifras",
        "openPost": "Abrir publicación"
      },
      "admin": {
        "dashboard": {
          "reloadModels": "Recargar modelos",
          "reloadScData": "Recargar datos SC",
          "reloadPaints": "Recargar pinturas",
          "reloadModules": "Recargar módulos",
          "reloadLoaners": "Recargar naves prestadas"
        },
        "supporterContributions": {
          "syncFromPatreon": "Sincronizar desde Patreon"
        },
        "imports": {
          "loadAll": "Cargar todo",
          "load": "Cargar",
          "loadScData": "Cargar datos de SC",
          "loadShipMatrix": "Cargar matriz de naves",
          "cleanup": "Marcar como fallida",
          "cleanupSelected": "Marcar la selección como fallida"
        }
      },
      "duplicate": "Duplicar",
      "upgrade": "¡Actualización disponible!",
      "backToHome": "Trazar nuevo rumbo",
      "disableGrouping": "Desactivar agrupación",
      "enableGrouping": "Activar agrupación",
      "groupedByModel": "Agrupado por modelo",
      "destroyAccount": "Eliminar cuenta",
      "saveScreenshot": "Guardar como PNG",
      "resolve": "Resolver",
      "sortBy": "Ordenar por",
      "back": "Atrás",
      "open": "Abrir",
      "copy": "Copiar",
      "download": "Descargar",
      "zoom": "Zoom",
      "viewImage": "Ver %{name} a tamaño completo",
      "more": "Más...",
      "export": "Exportar",
      "exportHangarLink": "Exportar a hangar.link",
      "import": "Importar",
      "here": "aquí",
      "previous": "Anterior",
      "next": "Siguiente",
      "cancel": "Cancelar",
      "ok": "Aceptar",
      "reset": "Restablecer",
      "reload": "Recargar",
      "retry": "Reintentar",
      "confirm": "Confirmar",
      "showDetailPage": "Página de detalles",
      "showDetails": "Mostrar detalles",
      "hideDetails": "Ocultar detalles",
      "showPledgeValue": "Mostrar valor de pledges",
      "showInGameBoughtValue": "Mostrar valor comprado en el juego",
      "readMore": "Leer más",
      "readLess": "Mostrar menos",
      "showGuide": "Mostrar el recorrido",
      "tour": {
        "next": "Siguiente",
        "back": "Atrás",
        "skip": "Saltar el recorrido",
        "done": "Listo"
      },
      "showFleetchart": "Diagrama de flota",
      "hideFleetchart": "Vista predeterminada",
      "fleetchartApp": {
        "useExtendedState": "Mostrar naves en estado extendido",
        "useRetractedState": "Mostrar naves en vuelo"
      },
      "showLabels": "Mostrar etiquetas",
      "hideLabels": "Ocultar etiquetas",
      "resetZoom": "Restablecer zoom",
      "supportUs": "Apoyar FleetYards.net",
      "installApp": {
        "cta": "Instalar app",
        "later": "Ahora no"
      },
      "supportHint": {
        "cta": "Apoyar FleetYards",
        "later": "Quizás más tarde"
      },
      "login": "Iniciar sesión",
      "signUp": "Registrarse",
      "confirmAccess": "Confirmar contraseña",
      "sendConfirmAccessEmail": "Enviar correo de confirmación",
      "reset-password": "¿Olvidó la contraseña?",
      "edit": "Editar",
      "clear": "Borrar",
      "done": "Hecho",
      "share": "Compartir",
      "change": "Cambiar",
      "upload": "Subir",
      "save": "Guardar",
      "enable": "Habilitar",
      "disable": "Deshabilitar",
      "manage": "Administrar",
      "enableGlobally": "Habilitar globalmente",
      "disableGlobally": "Deshabilitar globalmente",
      "addActor": "Agregar actor",
      "addGroup": "Añadir grupo",
      "editGroup": "Editar grupo",
      "remove": "Eliminar",
      "reorder": "Reordenar",
      "moveUp": "Subir",
      "moveDown": "Bajar",
      "delete": "Borrar",
      "deleteSelected": "Borrar seleccionados",
      "enableSelected": "Activar seleccionados",
      "disableSelected": "Desactivar seleccionados",
      "presets": {
        "choose": "Elegir una imagen",
        "remove": "Quitar la imagen"
      },
      "close": "Cerrar",
      "filter": "Filtrar",
      "showStatusColor": "Mostrar estado como color",
      "hideStatusColor": "Ocultar estado como color",
      "addToHangar": "Añadir al hangar",
      "blueprint": {
        "own": "Marcar como en posesión",
        "unown": "Quitar la marca"
      },
      "resetFilter": "Restablecer filtro",
      "requestPassword": "Solicitar email de contraseña",
      "changePassword": "Cambiar contraseña",
      "updatePassword": "Actualizar contraseña",
      "copyBackupCodes": "Copiar códigos de respaldo",
      "regenerate": "Regenerar",
      "add": "Añadir",
      "create": "Crear",
      "addToWishlist": "Añadir a lista de deseos",
      "addVehicle": "Añadir naves",
      "showTableView": "Lista",
      "showGridView": "Cuadrícula",
      "linkExisting": "Vincular existente",
      "loadMore": "Cargar más",
      "unlink": "Desvincular",
      "syncRsiBuybacks": "Sincronizar recompras de RSI",
      "syncRsiHangar": "Sincronizar hangar RSI",
      "oauthApplications": {
        "create": "Nueva aplicación",
        "regenerateSecret": "Regenerar secreto",
        "approve": "Aprobar",
        "reject": "Rechazar",
        "rejectSelected": "Rechazar seleccionadas"
      },
      "oauthAuthorize": {
        "authorize": "Autorizar",
        "deny": "Denegar"
      },
      "verifyWithCitizenId": "Verificar con Citizen iD",
      "user": {
        "rsiVerification": {
          "verify": "Verificar mediante perfil de RSI",
          "check": "Comprobar ahora",
          "checkIn": "Comprobar de nuevo en %{seconds} s",
          "copyToken": "Copiar código",
          "regenerateToken": "Generar un código nuevo",
          "revoke": "Revocar"
        }
      },
      "oauth": {
        "signInWith": "Iniciar sesión con",
        "google": "Google",
        "discord": "Discord",
        "bluesky": "BlueSky",
        "github": "GitHub",
        "twitch": "Twitch",
        "citizenid": "Citizen iD",
        "connected": {
          "google": "Conectado a Google",
          "discord": "Conectado a Discord",
          "bluesky": "Conectado a BlueSky",
          "github": "Conectado a GitHub",
          "twitch": "Conectado a Twitch",
          "citizenid": "Conectado a Citizen iD",
          "patreon": "Conectado a Patreon"
        },
        "disconnect": {
          "google": "Desconectar Google",
          "discord": "Desconectar Discord",
          "bluesky": "Desconectar BlueSky",
          "github": "Desconectar GitHub",
          "twitch": "Desconectar Twitch",
          "citizenid": "Desconectar Citizen iD",
          "patreon": "Desconectar Patreon"
        },
        "patreon": "Patreon"
      },
      "compare": {
        "ships": "Comparar"
      },
      "cargoGrids": {
        "addShips": "Añadir naves"
      },
      "tradeRoutes": {
        "pickShip": "Elegir nave",
        "changeShip": "Cambiar nave",
        "editRun": "Editar",
        "doneEditing": "Listo",
        "backToRuns": "Volver a todos los viajes",
        "showMore": "Mostrar más viajes"
      },
      "hangar": {
        "editGroups": "Añadir o eliminar grupos",
        "editName": "Nombrar tu nave",
        "manageLoadouts": "Gestionar configuraciones",
        "manageCargo": "Gestionar carga",
        "useName": "Usar nombre",
        "destroyAll": "Eliminar todas las naves",
        "showOnPublicHangar": "Hacer público",
        "hideFromPublicHangar": "Ocultar del público",
        "editGroupsSelected": "Añadir/Eliminar de grupos",
        "resetIngame": {
          "openModal": "Restablecer naves del juego después del wipe",
          "moveToWishlist": "Mover a lista de deseos",
          "removeAll": "Eliminar todo"
        }
      },
      "syncExtension": {
        "cancel": "Cancelar",
        "start": "Iniciar sincronización",
        "changeInSettings": "Cambiar en los ajustes",
        "retry": "Reintentar sincronización",
        "runInBackground": "Continuar en segundo plano",
        "showResult": "Mostrar resultado",
        "close": "Cerrar",
        "refresh": "Actualizar página"
      },
      "empty": {
        "hangarGuide": "Hacer el recorrido",
        "reset": "Borrar filtros"
      },
      "destroyFleet": "Destruir flota",
      "restore": "Restaurar",
      "fleet": {
        "fidClaim": {
          "claim": "Reclamar %{fid}",
          "withdraw": "Retirar la reclamación",
          "useSuggestion": "Usar %{suggestion}",
          "endNow": "Terminar ya el periodo de gracia",
          "cancel": "Cancelar la reclamación"
        },
        "rsiVerification": {
          "verify": "Verificar",
          "regenerateToken": "Generar un código nuevo",
          "check": "Comprobar ahora",
          "copyToken": "Copiar código",
          "revoke": "Revocar"
        },
        "join": "¡Unirse a %{fleet}!",
        "leave": "Abandonar %{fleet}",
        "createInviteUrl": "Crear URLs de invitación",
        "inviteMember": "Invitar nuevo miembro",
        "squadrons": {
          "create": "Crear escuadrón",
          "addMember": "Añadir miembros",
          "removeMember": "Quitar del escuadrón",
          "addMembers": "Añadir %{count}",
          "viewMembers": "Miembros del escuadrón",
          "viewShips": "Naves del escuadrón",
          "viewStats": "Estadísticas del escuadrón",
          "join": "Unirse al equipo",
          "leave": "Salir",
          "requestJoin": "Solicitar ingreso",
          "withdrawRequest": "Retirar solicitud",
          "acceptRequest": "Aceptar",
          "declineRequest": "Rechazar",
          "promote": "Ascender",
          "demote": "Degradar"
        },
        "manageInvites": "Invitaciones",
        "worldmap": "Mapa mundial",
        "starmap": "Mapa estelar",
        "acceptInvite": "Aceptar invitación",
        "declineInvite": "Rechazar invitación",
        "acceptRequest": "Aceptar solicitud",
        "declineRequest": "Rechazar solicitud",
        "members": {
          "invite": "Invitar",
          "promote": "Promover",
          "demote": "Degradar",
          "accept": "Aceptar",
          "decline": "Rechazar",
          "remove": "Eliminar",
          "editRole": "Editar rol",
          "editNickname": "Editar apodo",
          "health": {
            "open": "Estado de los miembros",
            "showAll": "Mostrar los %{count}",
            "inviteLinks": "Enlaces de invitación",
            "discordSettings": "Ajustes de Discord",
            "verifyOrg": "Verificar la organización de RSI",
            "remove": "Expulsar de la flota",
            "revoke": "Retirar invitación",
            "deleteLink": "Eliminar enlace",
            "promoteTo": "Ascender a %{role}",
            "addToSquadron": "Añadir a un escuadrón",
            "addMembers": "Añadir miembros",
            "deleteSquadron": "Disolver",
            "remind": "Recordar verificar"
          }
        },
        "inviteUrls": {
          "create": "Crear nueva URL de invitación"
        },
        "discord": {
          "test": "Probar conexión con Discord",
          "installBot": "Instalar el bot de Fleetyards en tu servidor de Discord"
        },
        "calendarSubscription": {
          "enable": "Generar enlace de suscripción",
          "rotate": "Rotar enlace",
          "disable": "Desactivar suscripción"
        }
      },
      "model": {
        "gallery": "Galería",
        "onSale": "En venta: %{price}",
        "store": "Página RSI"
      },
      "models": {
        "sync": "Sincronizar desde RSI",
        "syncMatrix": "Sincronizar matriz",
        "syncScData": "Sincronizar datos SC",
        "importPaints": "Importar pinturas",
        "exchangeStoreImage": "Usar imagen RSI",
        "images": "Imágenes",
        "openTableConfiguration": "Abrir configuración de tabla"
      },
      "users": {
        "loginAs": "Iniciar sesión como usuario",
        "resendConfirmation": "Reenviar confirmación",
        "sendPasswordReset": "Enviar restablecimiento de contraseña"
      },
      "unselect": "Deseleccionar todo",
      "twoFactor": {
        "enable": "Activar doble factor",
        "disable": "Desactivar doble factor",
        "generateBackupCodes": "Generar códigos de respaldo"
      },
      "holoViewer": {
        "autoRotate": {
          "enable": "Activar rotación automática",
          "disable": "Desactivar rotación automática"
        },
        "zoom": {
          "enable": "Activar zoom",
          "disable": "Desactivar zoom"
        },
        "color": {
          "enable": "Activar colores",
          "disable": "Desactivar colores"
        }
      },
      "logistics": {
        "createInventory": "New Inventory",
        "submit": "Submit",
        "reject": "Reject",
        "cancel": "Cancel",
        "deposit": "Deposit",
        "withdraw": "Withdraw",
        "createItem": "Add Item",
        "importCsv": "Import CSV",
        "downloadTemplate": "Download Template",
        "destroyEntry": "Delete Entry",
        "editStockItem": "Edit Item",
        "destroyStockItem": "Delete Item",
        "editInventory": "Edit Inventory",
        "clearCargo": "Vaciar carga",
        "viewCargoGrid": "Ver cuadrícula de carga",
        "sendTransfer": "Enviar",
        "moveStock": "Mover",
        "transfer": "Transferir",
        "acceptTransfer": "Aceptar",
        "declineTransfer": "Rechazar",
        "cancelTransfer": "Cancelar",
        "reportTransfer": "Denunciar",
        "resetToMax": "Restablecer al máximo",
        "removeLine": "Quitar"
      },
      "adminNotifications": {
        "read": "Marcar como leída",
        "unread": "Marcar como no leída",
        "archive": "Archivar",
        "unarchive": "Devolver a la bandeja de entrada",
        "readAll": "Marcar todas como leídas",
        "destroyAll": "Borrar todas",
        "sortOldest": "Más antiguas primero",
        "sortNewest": "Más recientes primero",
        "select": "Seleccionar notificación",
        "readSelected": "Marcar seleccionadas como leídas",
        "unreadSelected": "Marcar seleccionadas como no leídas",
        "archiveSelected": "Archivar seleccionadas",
        "unarchiveSelected": "Devolver seleccionadas a la bandeja de entrada",
        "destroySelected": "Borrar seleccionadas"
      },
      "account": {
        "calendarSubscription": {
          "enable": "Generar enlace de calendario personal",
          "rotate": "Rotar enlace",
          "disable": "Desactivar suscripción"
        }
      },
      "today": "Hoy",
      "fleets": {
        "missions": {
          "publish": "Publicar",
          "create": "Crear misión",
          "edit": "Editar misión",
          "archive": "Archivar misión",
          "unarchive": "Desarchivar",
          "destroy": "Borrar permanentemente",
          "addTeam": "Añadir equipo",
          "addShip": "Añadir nave",
          "addSlot": "Añadir slot",
          "viewMissions": "Ver misiones"
        },
        "tours": {
          "viewTours": "Ver rutas"
        },
        "events": {
          "create": "Crear evento",
          "edit": "Editar evento",
          "spawn": "Generar desde esta misión",
          "archive": "Archivar evento",
          "unarchive": "Restaurar del archivo",
          "syncToDiscord": "Sincronizar con Discord",
          "destroy": "Borrar permanentemente",
          "publish": "Publicar",
          "lockSignups": "Bloquear inscripciones",
          "unlockSignups": "Desbloquear inscripciones",
          "start": "Iniciar",
          "complete": "Completar",
          "cancel": "Cancelar",
          "signup": "Inscribirse",
          "withdraw": "Retirarse",
          "kick": "Eliminar inscripción",
          "addToCalendar": "Añadir al calendario",
          "subscribe": "Suscribirse",
          "setUpCalendar": "Configurar suscripciones de calendario",
          "assignSlot": "Asignar a un slot",
          "reassignSlot": "Mover a otro slot",
          "manageEventTeam": "Gestionar el equipo del evento",
          "grantRole": "Conceder rol",
          "revokeRole": "Revocar",
          "addTeam": "Añadir equipo"
        },
        "contracts": {
          "create": "Crear contrato",
          "save": "Guardar contrato",
          "publish": "Publicar",
          "claim": "Aceptar",
          "join": "Pedir unirse",
          "release": "Abandonar",
          "fulfil": "Marcar completado",
          "cancel": "Cancelar contrato",
          "edit": "Editar",
          "leave": "Salir",
          "remove": "Quitar",
          "acceptCrew": "Aceptar",
          "declineCrew": "Rechazar",
          "addItem": "Añadir mercancías",
          "payouts": "Pagos"
        }
      },
      "notifications": {
        "read": "Marcar como leída",
        "unread": "Marcar como no leída",
        "archive": "Archivar",
        "unarchive": "Devolver a la bandeja de entrada",
        "readAll": "Marcar todas como leídas",
        "destroyAll": "Borrar todas",
        "settings": "Configuración de notificaciones",
        "sortOldest": "Más antiguas primero",
        "sortNewest": "Más recientes primero",
        "openCenter": "Notificaciones",
        "pushEnable": "Activar en este dispositivo",
        "pushDisable": "Desactivar en este dispositivo",
        "pushRemove": "Quitar",
        "select": "Seleccionar notificación",
        "readSelected": "Marcar seleccionadas como leídas",
        "unreadSelected": "Marcar seleccionadas como no leídas",
        "archiveSelected": "Archivar seleccionadas",
        "unarchiveSelected": "Devolver seleccionadas a la bandeja de entrada",
        "destroySelected": "Borrar seleccionadas"
      },
      "unlistedModel": {
        "createModel": "Crear nave",
        "markAsPaint": "Es una pintura",
        "ignore": "Ignorar",
        "noManufacturer": "Este identificador no resuelve ningún fabricante",
        "alreadyExists": "%{name} ya está en el catálogo",
        "link": "Ya está en el catálogo",
        "markAsPaintSelected": "Marcar la selección como pinturas",
        "ignoreSelected": "Ignorar la selección"
      },
      "revert": "Revertir",
      "exportCsv": "Exportar CSV",
      "exportAllCsv": "Exportar todo como CSV",
      "imports": {
        "cancel": "Cancelar",
        "downloadExample": "Archivo de ejemplo",
        "toggleDetails": "Ver qué ocurrió"
      },
      "selectFile": "Seleccionar archivo",
      "applyGameFileValue": "Aplicar",
      "applyAllGameFileValues": "Aplicar todo",
      "payouts": {
        "archiveTour": "Archivar",
        "unarchiveTour": "Restaurar",
        "deleteTour": "Eliminar",
        "openLedger": "Abrir libro de pagos",
        "addEntry": "Registrar dinero",
        "addParticipant": "Añadir participante",
        "settle": "Liquidar y calcular pagos",
        "reopen": "Reabrir",
        "confirm": "Marcar como pagado",
        "unconfirm": "Marcar como no pagado",
        "createTour": "Crear expedición",
        "joinTour": "Unirse",
        "rotateInvite": "Generar un enlace nuevo",
        "askToJoin": "Solicitar participar",
        "withdrawJoinRequest": "Retirar solicitud",
        "approveJoinRequest": "Aceptar",
        "declineJoinRequest": "Rechazar",
        "approveExpense": "Aprobar",
        "declineExpense": "Rechazar"
      },
      "relationships": {
        "accept": "Aceptar",
        "decline": "Rechazar",
        "ignore": "Ignorar",
        "withdraw": "Retirar",
        "end": "Eliminar",
        "send": "Enviar solicitud",
        "user": {
          "add": "Añadir amigo"
        },
        "fleet": {
          "add": "Añadir aliado"
        }
      },
      "supporterNomination": {
        "change": "Cambiar de flota"
      },
      "vehicleOverview": {
        "open": "Resumen",
        "uploadPicture": "Subir una imagen",
        "changePicture": "Cambiar imagen",
        "edit": "Editar nave",
        "shipDatabase": "Base de datos de naves",
        "openLog": "Abrir el cuaderno",
        "applyPaint": "Aplicar %{paint}",
        "choosePaint": "Elegir pintura",
        "editLocation": "Cambiar ubicación",
        "allPaints": "Las %{count} pinturas",
        "fullscreenHolo": "Pantalla completa"
      },
      "vehicleLog": {
        "open": "Cuaderno de bitácora",
        "add": "Nueva entrada",
        "showPublic": "Cuaderno de bitácora"
      }
    }
  }
}
